exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-notification[data-v-63b28f3a]{position:relative;height:3.2rem}.notification-field[data-v-63b28f3a]{padding:0;margin:0;width:50rem;height:26.4rem}", ""]);

